import React, {
  createContext,
  ElementType,
  ReactNode,
  useContext,
  useRef,
} from "react";
import { Link } from "react-router-dom";
import { runInitSidebarActiveMenu } from "Common/sidebarActiveMenuDom";
import { safeRouterTo } from "Common/safeRouterTo";
interface DropdownContextType {
  toggleOpen: any;
}
const DropDownContext = createContext<DropdownContextType | undefined>(
  undefined
);
interface DropdownProps {
  children?: ReactNode;
  as?: ElementType;
  className?: string;
  active?: any;
  id?: any;
  subitemId?: any;
}
const Dropdown = ({
  as: Component = "div",
  children,
  className,
  id,
  subitemId,
}: DropdownProps) => {
  const toggleOpen = (ref: any) => {
    if (ref) {
      activateParentDropdown(ref);
    } else {
      runInitSidebarActiveMenu(
        typeof window !== "undefined" ? window.location.pathname : "/"
      );
    }
  };

  const activateParentDropdown = (item: any) => {
    if (!item?.classList) return;
    item.classList.add("active");
    const openDropdowns = document.querySelectorAll(".dropdown-button.active");
    const mainAttrItem = item?.closest("div[main-item]");

    openDropdowns.forEach((dropdown: any) => {
      dropdown.classList.remove("active", "show");
      const dropdownsToShow = dropdown
        ?.closest("div[main-item]")
        ?.querySelectorAll("div.dropdown-content:not(.hidden)");
      if (dropdownsToShow && dropdownsToShow.length > 0)
        dropdownsToShow.forEach((elem: any) => {
          elem.classList.add("hidden");
        });
    });

    item.classList.add("active");
    if (
      !(
        document.documentElement.getAttribute("data-layout") === "vertical" &&
        document.documentElement.getAttribute("data-sidebar-size") === "sm"
      )
    )
      item.nextElementSibling?.classList.remove("hidden");
    let parentCollapseDiv = item?.closest(".dropdown-content");
    const parentDropButton = parentCollapseDiv?.parentElement?.firstChild;
    parentDropButton?.classList.add("active");
    parentDropButton?.classList.add("show");
    parentDropButton?.parentElement
      ?.querySelector(".dropdown-content")
      ?.classList.remove("hidden");

    if (parentDropButton) {
      const parentParentCollapseDiv =
        parentDropButton?.closest(".dropdown-content");
      const parentParentDropButton =
        parentParentCollapseDiv?.parentElement?.firstChild;
      parentParentDropButton?.classList.add("active");
      parentParentDropButton?.classList.add("show");
      parentParentDropButton?.parentElement
        ?.querySelector(".dropdown-content")
        ?.classList.remove("hidden");
    }

    mainAttrItem?.classList.add("active", "show");
    if (
      !(
        document.documentElement.getAttribute("data-layout") === "vertical" &&
        document.documentElement.getAttribute("data-sidebar-size") === "sm"
      )
    )
      mainAttrItem
        ?.querySelector(".dropdown-content")
        ?.classList.remove("hidden");
  };

  return (
    <DropDownContext.Provider value={{ toggleOpen }}>
      <Component
        main-item={id}
        sub-item={subitemId}
        className={`dropdown ${className}`}
      >
        {children}
      </Component>
    </DropDownContext.Provider>
  );
};
interface TriggerProps {
  children: ReactNode;
  type?: ElementType;
  className?: string;
  id?: string;
  href?: any;
}
export const Trigger: React.FC<TriggerProps> = ({
  children,
  className,
  id,
}) => {
  const { toggleOpen } = useContext(DropDownContext)!;
  const contentRef = useRef<any>(null);
  return (
    <>
      <Link
        ref={contentRef}
        id={id}
        to={safeRouterTo("/")}
        onClick={(e: any) => {
          e.preventDefault();
          toggleOpen(contentRef.current);
        }}
        className={className}
      >
        {children}
      </Link>
    </>
  );
};
interface ContentProps {
  as?: ElementType;
  className?: string;
  children: ReactNode;
  currentPath?: any;
}
const Content: React.FC<ContentProps> = ({
  as: Component = "div",
  className,
  children,
}) => {
  const getClassName = className
    ? className
    : "absolute z-50 py-2 mt-1 text-left list-none bg-white rounded-md shadow-md dropdown-menu min-w-max dark:bg-zink-400";
  return <Component className={getClassName}>{children}</Component>;
};

Dropdown.Trigger = Trigger;
Dropdown.Content = Content;
export { Dropdown };
